import { useMutation } from '@tanstack/react-query';

import type { ContactCandidateData } from '../useContactCandidateMutation.types';

import { encodeBase64 } from 'helpers/base64';
import { useSendLinkedinMessageMutation } from 'shared/legacy/hooks/useBrowserExtension/linkedin/useSendLinkedinMessageMutation';
import { useBrowserExtension } from 'shared/legacy/hooks/useBrowserExtension/useBrowserExtension';
import { useCurrentUserQuery } from 'shared/legacy/hooks/useCurrentUserQuery';
import { htmlToPlainText } from 'utils/shared/htmlToPlainText';
import { extractEsPersonId } from '../utils/extractEsPersonId';

export const useContactLinkedinMutation = () => {
  const { data: currentUser } = useCurrentUserQuery();
  const { sendLinkedinConnectionRequest, existsLinkedinConversationWithCandidate } = useBrowserExtension();

  const sendLinkedinMessage = useSendLinkedinMessageMutation();

  return useMutation(async (params: ContactCandidateData<'linkedin'>) => {
    let thread_id = undefined;
    const { esPersonId, message } = params;
    const esPersonIdWithoutPlatform = extractEsPersonId(esPersonId);

    const candidateConversation = await existsLinkedinConversationWithCandidate(esPersonIdWithoutPlatform);

    if (candidateConversation !== undefined) {
      const response = await sendLinkedinMessage.mutateAsync({
        text: htmlToPlainText(message),
        candidateConversation,
      });

      if (response.status === 200) {
        thread_id = encodeBase64(`${currentUser?.id}-${esPersonId}`);
      }
    } else {
      const response = await sendLinkedinConnectionRequest({
        ...(message !== undefined && {
          customMessage: htmlToPlainText(message),
        }),
        inviteeProfileUrn: `urn:li:fsd_profile:${esPersonIdWithoutPlatform}`,
      });

      if (response.status === 200) {
        thread_id = encodeBase64(`${currentUser?.id}-${esPersonId}`);
      }
    }

    return { thread_id };
  });
};
